(function initComplementaryProductsSwiper() {
  const container = document.querySelector('.complementary-products-container');
  if (!container) return;

  const swiperContainer = container.querySelector('swiper-container');
  if (!swiperContainer) return;

  if (typeof swiperContainer.initialize === 'function') {
    swiperContainer.initialize();
  }
})();
